/* eslint-disable react/prop-types */ // TODO: add props
import Immutable from 'immutable';
import cx from 'classnames';
import { SortColumns } from './constants';
import styles from './LessonProgressHeaderRow.scss';
import { Table } from 'edrolo/domains/teacherResultsTable';
import {
  getGuidingQuestionLastChunkIds,
  getGuidingQuestionFirstChunkIds,
} from '../../utils';

const createColumnHeaderComponent = (
  onClick,
  currentSortColumn,
  isDescending
) => {
  return ({ isHorizSticky, columnName, children, className }) => {
    const sortSpan = columnName === currentSortColumn && (
      <span className={isDescending ? styles.desc : styles.asc} />
    );
    return (
      <Table.ColHeader
        onClick={() => onClick(columnName)}
        isSticky
        isHorizSticky={isHorizSticky}
        className={cx(styles.sortable, className)}
      >
        {children}
        {sortSpan}
      </Table.ColHeader>
    );
  };
};

const LessonProgressHeaderRow = ({
  chunks,
  onSort,
  lessonProgressData = Immutable.List(),
  currentSortColumn,
  isDescending,
  studentProgressSuccessMeasureResponses,
  shouldShowSelfRating,
  shouldShowStudentNotes,
}) => {
  // create our ColumnHeader with its standard values
  const ColumnHeader = createColumnHeaderComponent(
    onSort,
    currentSortColumn,
    isDescending
  );

  const columnHeaderClassName = cx(
    styles.colHeader,
    styles.lightestGreyBackgroundHeader
  );

  const lastGuidingQuestionLastChunkId =
    getGuidingQuestionLastChunkIds(chunks).last();

  const guidingQuestionFirstChunkIds = getGuidingQuestionFirstChunkIds(chunks);

  const chunkHeaders = chunks.map((chunk) => {
    let headerCell;
    const chunkQuestion = chunk.get('question');

    if (chunk.get('success_measure')) {
      const classSize = lessonProgressData.size;
      const numStudentsRespondedWithYes =
        studentProgressSuccessMeasureResponses?.filter(
          (record) =>
            record.get('success_measure_id') ==
              chunk.getIn(['success_measure', 'id']) &&
            record.get('value') == 'yes'
        )?.size || 0;
      headerCell = (
        <Table.ColHeader
          key={`${chunk.get('id')}-success-measure-header`}
          className={cx(columnHeaderClassName, {
            [styles.lastGuidingQuestionLastChunk]:
              lastGuidingQuestionLastChunkId === chunk.get('id'),
          })}
          isSticky
        >
          <div className={styles.successMeasureHeaderContent}>
            <strong>
              {numStudentsRespondedWithYes}/{classSize}
            </strong>{' '}
            students self-rated success measure as <strong>confident</strong>
          </div>
        </Table.ColHeader>
      );
    }

    // Don't show header for review questions,
    // or free text question without review questions (which will have marks_available=0)
    else if (
      chunkQuestion &&
      chunkQuestion.get('marks_available') &&
      !chunkQuestion.get('question_to_review')
    ) {
      const quizResults = lessonProgressData
        .map((profileRow) =>
          profileRow.getIn([
            'progress',
            'quiz_results',
            chunkQuestion.get('id').toString(),
          ])
        )
        .filter((quizResult) => quizResult); // remove students without responses

      const numStudentsResponded = quizResults.size;
      const numStudentsRespondedCorrectly = quizResults.filter(
        (quizResult) => quizResult.get('marks_obtained') > 0
      ).size;

      headerCell = (
        <Table.ColHeader
          key={`${chunk.get('id')}-correctly-answered-header`}
          className={cx(columnHeaderClassName, {
            [styles.guidingQuestionFirstChunks]:
              guidingQuestionFirstChunkIds.includes(chunk.get('id')),
          })}
          isSticky
        >
          <div className={styles.correctlyAnsweredHeader}>
            <strong>
              {numStudentsRespondedCorrectly}/{numStudentsResponded}
            </strong>{' '}
            students correct
          </div>
        </Table.ColHeader>
      );
    } else {
      headerCell = (
        <Table.ColHeader
          className={cx(columnHeaderClassName, {
            [styles.guidingQuestionFirstChunks]:
              guidingQuestionFirstChunkIds.includes(chunk.get('id')),
          })}
          isSticky
          key={chunk.get('id')}
        />
      );
    }

    return headerCell;
  });

  return (
    <Table.Row className={styles.headerRow} data-test="lesson-progress-header">
      {/** Ensure number of <ColumnHeader /> used below matches number of <EmptyHeaderCell /> in <LessonProgressSuperHeaderRow /> */}
      <ColumnHeader
        isHorizSticky
        columnName={SortColumns.NAME}
        className={cx(columnHeaderClassName, styles.studentNameHeader)}
      >
        Student name
      </ColumnHeader>
      <ColumnHeader
        columnName={SortColumns.VIEWED}
        className={cx(columnHeaderClassName, styles.lessonContentViewedHeader)}
      >
        Lesson content viewed
      </ColumnHeader>
      <ColumnHeader
        columnName={SortColumns.QUIZZES}
        className={cx(columnHeaderClassName, styles.AverageQuizScoreHeader)}
      >
        Average quiz score
      </ColumnHeader>
      {shouldShowSelfRating && (
        <ColumnHeader
          columnName={SortColumns.SELF_RATING}
          className={cx(columnHeaderClassName, styles.SelfRatingHeader)}
        >
          Rating
        </ColumnHeader>
      )}
      {shouldShowStudentNotes && (
        <ColumnHeader
          columnName={SortColumns.STUDENT_NOTES}
          className={cx(
            columnHeaderClassName,
            styles.studentNotebookLinkHeader
          )}
        >
          Student notes
        </ColumnHeader>
      )}
      {chunkHeaders}
    </Table.Row>
  );
};

export default LessonProgressHeaderRow;
